var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ header: _vm.hasHeader },attrs:{"id":"app"}},[_c('keep-alive',[(!this.$route.meta.noKeepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1),(this.$route.meta.noKeepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }